import { Button } from "@whitespace/components";
import clsx from "clsx";
import { add, format, parseISO } from "date-fns";
import PropTypes from "prop-types";
import React from "react";

import * as defaultStyles from "./Timeslot.module.css";

Timeslot.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  pass: PropTypes.object,
  handleCreateBooking: PropTypes.func,
};

export default function Timeslot({
  styles = defaultStyles,
  className,
  pass,
  handleCreateBooking,
}) {
  const endTime = format(
    add(parseISO("1970-01-01 " + pass.StartTime), {
      minutes: pass.LengthMinutes,
    }),
    "HH:mm",
  );

  return (
    <Button
      className={clsx(styles.component, className)}
      onClick={() => handleCreateBooking(pass.PassNo)}
      disabled={!pass.available}
    >
      {`${pass.StartTime}–${endTime}`}
    </Button>
  );
}
